import styled from 'styled-components';

export const TimeTextWrapper = styled.span`
    // In most contexts, we want times with the same number of digits to take up the same
    // amount of horizontal space (e.g. as the timer counts in the player, we don't want the
    // count to jump around as the digist change). So the one styling assistance TimeText offers
    // is making sure to use Tabular Figures ("tnum"), so numbers are essentially monospaced.
    font-feature-settings: 'tnum' 1;
`;
